(() => {
  if (window.RoyalHomeMedia) return;
  const roots = new WeakSet();
  function prepare(slide) {
    if (!slide) return;
    slide.querySelectorAll('source[data-rh-srcset]').forEach(source => {
      source.srcset = source.dataset.rhSrcset;
      source.removeAttribute('data-rh-srcset');
    });
    slide.querySelectorAll('img[data-rh-src]').forEach(image => {
      image.setAttribute('data-rh-media','');
      image.loading = 'eager';
      image.fetchPriority = 'low';
      if (image.dataset.rhSrcset) image.srcset = image.dataset.rhSrcset;
      image.src = image.dataset.rhSrc;
      image.removeAttribute('data-rh-src');
      image.removeAttribute('data-rh-srcset');
    });
    return Promise.all(Array.from(slide.querySelectorAll('picture img,img[data-rh-media]')).map(image => {
      if (image.decode) return image.decode().catch(() => {});
      if (image.complete) return Promise.resolve();
      return new Promise(resolve => {
        image.addEventListener('load', resolve, {once:true});
        image.addEventListener('error', resolve, {once:true});
      });
    }));
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-rh-carousel]').forEach(root => {
      if (roots.has(root) || root.dataset.designMode === 'true') return;
      roots.add(root);
      const track = root.querySelector('[data-rh-slides]');
      const slides = Array.from(track?.querySelectorAll('.rh-slide') || []).filter(slide => !slide.dataset.rhClone);
      if (!slides.length) return;
      let visible = false, frame = 0;
      const currentIndex = () => Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / (track.clientWidth || 1))));
      const next = () => {
        if (!root.isConnected || !visible || document.hidden) return;
        const index = currentIndex();
        prepare(slides[index]);
        const image = slides[index].querySelector('picture img');
        if (!image || image.complete) prepare(slides[(index + 1) % slides.length]);
      };
      const afterPaint = () => requestAnimationFrame(() => requestAnimationFrame(next));
      root.addEventListener('load', event => {
        if (event.target.matches('picture img')) afterPaint();
      }, true);
      root.addEventListener('error', afterPaint, true);
      const adjacent = () => { const i = currentIndex(); [i, (i + 1) % slides.length, (i + slides.length - 1) % slides.length].forEach(n => prepare(slides[n])); };
      root.addEventListener('pointerdown', adjacent, {passive:true});
      root.addEventListener('keydown', event => {
        if (event.key === 'Home') prepare(slides[0]);
        else if (event.key === 'End') prepare(slides[slides.length - 1]);
        else if (['ArrowLeft','ArrowRight'].includes(event.key)) adjacent();
      });
      track.addEventListener('scroll', () => {
        if (frame) return;
        frame = requestAnimationFrame(() => { frame = 0; next(); });
      }, {passive:true});
      document.addEventListener('visibilitychange', next);
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; if (visible) next(); }, {threshold:0.1});
        observer.observe(root);
      } else {
        visible = true;
        slides.forEach(prepare);
      }
    });
  }
  window.RoyalHomeMedia = {prepare};
  init();
  document.addEventListener('shopify:section:load', () => init());
})();
